// This list is also present in dashboard-v2
// Both should be kept in sync. Here is to restrict user. THere to configure it in UI
export const PWAEnrollmentFields = [
  "name",
  "mobile",
  "email",
  "gender",
  "dob",
  "anniversary",
  "maritalStatus",
  "customBusinessFields_cnf1",
  "customBusinessFields_cnf2",
  "customBusinessFields_cnf3",
  "customBusinessFields_cnf4",
  "customBusinessFields_cnf5",
  "customBusinessFields_csf1",
  "customBusinessFields_csf2",
  "customBusinessFields_csf3",
  "customBusinessFields_csf4",
  "customBusinessFields_csf5",
  "customBusinessFields_csf6",
  "customBusinessFields_csf7",
  "customBusinessFields_csf8",
  "customBusinessFields_csf9",
  "customBusinessFields_csf10",
  "customBusinessFields_cdf1",
  "customBusinessFields_cdf2",
  "customBusinessFields_cdf3",
  "customBusinessFields_cdf4",
  "customBusinessFields_cdf5",
  "registeredStore",
  "address_city",
  "address_state",
  "address_country",
  "address_address2",
  "address_address1",
  "address_pincode",
];
export const USER_PWAEnrollmentFields = [
  "address_city",
  "address_state",
  "address_country",
  "address_address2",
  "address_address1",
  "address_pincode",
];
export const userProfileMap = [
  {
    name: "name",
    label: "name",
  },
  {
    name: "mobile",
    label: "mobile number",
  },
  {
    name: "email",
    label: "email",
  },
  {
    name: "gender",
    label: "gender",
  },
  {
    name: "birthday",
    label: "birthday",
  },
  {
    name: "anniversary",
    label: "anniversary",
  },
  {
    name: "maritalStatus",
    label: "marital status",
  },
  {
    name: "children",
    label: "Children Details",
  },
];

const gender = [
    {
      label: "Male",
      value: "Male",
    },
    {
      label: "Female",
      value: "Female",
    },
    {
      label: "Trans-Gender",
      value: "Trans-gender",
    },
    {
      label: "Prefer not to Disclose",
      value: "Prefer not to disclose",
    },
  ];

  const maritalStatus = [
    {label: 'Single', value: 'Single'},
    {label: 'Married', value: 'Married'},
  ];

  const shoeSizes = [
  {label: 'UK 3', value: 'UK 3'},
  {label: 'UK 4', value: 'UK 4'},
  {label: 'UK 5', value: 'UK 5'},
  {label: 'UK 6', value: 'UK 6'},
  {label: 'UK 7', value: 'UK 7'},
  {label: 'UK 8', value: 'UK 8'},
  {label: 'UK 9', value: 'UK 9'},
  {label: 'UK 10', value: 'UK 10'},
  {label: 'UK 11', value: 'UK 11'},
  {label: 'UK 12', value: 'UK 12'}
];

const placeOfRegistration = [
  'Home', 
  'Store'
]

const cities = [
  'Ahmedabad', 'Anand', 'Bengaluru', 'Delhi', 'Gandhidham', 'Gurgaon', 'Mumbai', 'Pune', 'Rajkot', 'Vadodara', 'Vapi'
]

const storesInCities = {
  "Delhi":
  [
      "Nike, Vegas Dwarka",
      "Nike, Ambience Mall",
      "Nike, Jawahar Nagar Kamla Ngr",
      "Nike, Sec-8, Rohini",
      "Nike, CP New (B-Block) (BDA Co.)",
      "Nike, Southex",
      "Nike, Select Mall",
      "Nike, DLF Vasant Kunj"
  ],
  "Pune":
  [
      "Nike, JM Road",
      "Nike, MG Road(308)",
      "Nike, My Mall Pune (Pavellion Mall)",
      "Nike, Phoenix Market City"
  ],
  "Mumbai":
  [
      "Nike, Colaba",
      "Nike, Linking1",
      "Nike, Colaba-4 (COCO)",
      "Nike,JWD",
      "Nike, Viviana Mall",
      "Nike, Malad Infinity Mall",
      "Nike, Malad Inorbit Mall",
      "Nike, Seawood Grand Central",
      "Nike, Ramee Emerald,Linking Road",
      "Nike, Andheri Infinity Mall",
      "Nike, Palladium",
      "Nike, Ghatkopar Mumbai",
      "Nike, Phoenix Bandra Kurla (Mum)",
      "Nike, Sky City",
  ],
  "Gurgaon":
  [
      "Nike, Ambiance Mall Gurgaon",
      "Nike, MGF Gurgaon",
      "Nike, Cyber Hub"
  ],
  "Bengaluru":
  [
      "Nike, Indra Nagar",
      "Nike, Brigade New",
      "Nike, Forum Mall",
      "Nike, Jaya Nagar",
      "Nike, Orion Mall",
      "Nike, Phoenix Mall",
      "Nike - Phoenix Mall of Asia",
      "Nike - Mantri Mall"
  ],
  "Ahmedabad":
  [
      "Nike, One Mall",
      "Nike, CG Road, New Ahmedabad",
      "Nike, Atlantis Mall, Prahalad Nagar",
      "Nike, 4D"
  ],
  "Vadodara":
  [
		"Nike, Shreem Shalini Mall, Alkapuri",
		"Nike, Inorbit Mall Vadodara"
  ],
  "Gandhidham":
  [
		"Nike, Gandhidham"
  ],
  "Anand":
  [
		"Nike, Anand"
  ],
  "Rajkot":
  [
		"Nike, Reliance Mega Mall, Rajkot"
  ],
  "Vapi":
  [
		"Nike, Vapi"
  ]
}

const DefaultFavIcon = "%PUBLIC_URL%/favicon.ico"

const PwaFormJson = {
  "title": "Welcome !",
  "description": "Join Us - Tell Us a Bit About Yourself",
  "pages": [
    {
      "name": "MemberDetails",
      "elements": [
        {
          "type": "text",
          "name": "name",
          "title": "Enter your Name:",
          "isRequired": true
        },
        {
          "type": "text",
          "name": "mobile",
          "title": "Enter your Mobile Number:",
          "isRequired": true,
          "validators": [
            {
              "type": "regex",
              "text": "Please enter a valid contact number",
              "regex": "^\\d{10}$"
            }
          ]
        },
        {
          "type": "text",
          "name": "email",
          "title": "Enter your Email Address:",
          "isRequired": true,
          "validators": [
            {
              "type": "email",
              "text": "Please enter a valid email address"
            }
          ],
          "inputType": "email"
        },
        {
          "type": "dropdown",
          "name": "gender",
          "title": "Select your Gender:",
          "isRequired": true,
          "choices": [
            "Male",
            "Female",
            "Trans-gender",
            "Prefer not to disclose"
          ]
        },
        {
          "type": "text",
          "name": "dob",
          "title": "Enter your Birthday:",
          "isRequired": true,
          "inputType": "date"
        },
        {
          "type": "dropdown",
          "name": "maritalStatus",
          "title": "Select your Marital Status:",
          "isRequired": true,
          "choices": [
            "Single",
            "Married"
          ]
        },
        {
          "type": "text",
          "name": "anniversary",
          "visibleIf": "{maritalStatus} = 'Married'",
          "title": "Enter your Anniversary:",
          "isRequired": true,
          "inputType": "date"
        },
        {
          "type": "text",
          "name": "customBusinessFields_csf2",
          "title": "Instagram ID",
          "placeholder": "@yourhandle"
        },
        {
          "type": "html",
          "name": "info_sizeChart",
          "html": "<a href='https://nike.casarewards.com/size-chart.pdf' target='_blank'> Download Size Chart (UK/India)</a>"
        },
        {
          "type": "dropdown",
          "name": "customBusinessFields_csf1",
          "title": "Shoe Size",
          "description": "Refer above chart size ",
          "defaultValue": "UK 3",
          "isRequired": true,
          "choices": [
            "UK 3",
            "UK 4",
            "UK 5",
            "UK 6",
            "UK 7",
            "UK 8",
            "UK 9",
            "UK 10",
            "UK 11",
            "UK 12"
          ]
        },
        {
            "type":"text",
            "name":"registeredStore",
            "visible":false
        },
        {
          "type": "dropdown",
          "name": "customBusinessFields_csf3",
          "title": "Place Of Registration",
          "enableIf": "{registeredStore} empty or {registeredStore} = 'ONLINE' or ({registeredStore} notempty and {registeredStore} <> 'NK006' and {registeredStore} <> 'NK012' and {registeredStore} <> 'NK020' and {registeredStore} <> 'NK022' and {registeredStore} <> 'NK024' and {registeredStore} <> 'NK026' and {registeredStore} <> 'NK056' and {registeredStore} <> 'NK076' and {registeredStore} <> 'NK095' and {registeredStore} <> 'NK097' and {registeredStore} <> 'NK114' and {registeredStore} <> 'NK117' and {registeredStore} <> 'NK162' and {registeredStore} <> 'NK175' and {registeredStore} <> 'NK177' and {registeredStore} <> 'NK178' and {registeredStore} <> 'NK213' and {registeredStore} <> 'NK249' and {registeredStore} <> 'NK269' and {registeredStore} <> 'NK336' and {registeredStore} <> 'NK340' and {registeredStore} <> 'NK342' and {registeredStore} <> 'NK348' and {registeredStore} <> 'NK349' and {registeredStore} <> 'NK362' and {registeredStore} <> 'NK367' and {registeredStore} <> 'NK368' and {registeredStore} <> 'NK371' and {registeredStore} <> 'NK372' and {registeredStore} <> 'NK373' and {registeredStore} <> 'NK374' and {registeredStore} <> 'NK376' and {registeredStore} <> 'NK377' and {registeredStore} <> 'NK378' and {registeredStore} <> 'NK379' and {registeredStore} <> 'NK380' and {registeredStore} <> 'NK381' and {registeredStore} <> 'NK382' and {registeredStore} <> 'NK383' and {registeredStore} <> 'NK384' and {registeredStore} <> 'NK385' and {registeredStore} <> 'NK386' and {registeredStore} <> 'NK387' and {registeredStore} <> 'NK388' and {registeredStore} <> 'NK389' and {registeredStore} <> 'NK390' and {registeredStore} <> 'NK391' and {registeredStore} <> 'NK392' and {registeredStore} <> 'NK393' and {registeredStore} <> 'NK394' and {registeredStore} <> 'NK395' and {registeredStore} <> 'NK396' and {registeredStore} <> 'NK397')",
          "defaultValueExpression": "iif({registeredStore} = 'ONLINE','',iif({registeredStore} notempty, 'Store', ''))",
          "isRequired": true,
          "readOnly": true,
          "choices": [
            "Home",
            "Store"
          ]
        },
        {
          "type": "dropdown",
          "name": "customBusinessFields_csf4",
          "title": "City",
          "enableIf": "{registeredStore} empty or {registeredStore} = 'NK006' or {registeredStore} = 'NK178' or ({registeredStore} notempty and {registeredStore} <> 'NK012' and {registeredStore} <> 'NK020' and {registeredStore} <> 'NK022' and {registeredStore} <> 'NK024' and {registeredStore} <> 'NK026' and {registeredStore} <> 'NK056' and {registeredStore} <> 'NK076' and {registeredStore} <> 'NK095' and {registeredStore} <> 'NK097' and {registeredStore} <> 'NK114' and {registeredStore} <> 'NK117' and {registeredStore} <> 'NK162' and {registeredStore} <> 'NK175' and {registeredStore} <> 'NK177' and {registeredStore} <> 'NK213' and {registeredStore} <> 'NK249' and {registeredStore} <> 'NK269' and {registeredStore} <> 'NK336' and {registeredStore} <> 'NK340' and {registeredStore} <> 'NK342' and {registeredStore} <> 'NK348' and {registeredStore} <> 'NK349' and {registeredStore} <> 'NK362' and {registeredStore} <> 'NK367' and {registeredStore} <> 'NK368' and {registeredStore} <> 'NK371' and {registeredStore} <> 'NK372' and {registeredStore} <> 'NK373' and {registeredStore} <> 'NK374' and {registeredStore} <> 'NK376' and {registeredStore} <> 'NK377' and {registeredStore} <> 'NK378' and {registeredStore} <> 'NK379' and {registeredStore} <> 'NK380' and {registeredStore} <> 'NK381' and {registeredStore} <> 'NK382' and {registeredStore} <> 'NK383' and {registeredStore} <> 'NK384' and {registeredStore} <> 'NK385' and {registeredStore} <> 'NK386' and {registeredStore} <> 'NK387' and {registeredStore} <> 'NK388' and {registeredStore} <> 'NK389' and {registeredStore} <> 'NK390' and {registeredStore} <> 'NK391' and {registeredStore} <> 'NK392' and {registeredStore} <> 'NK393' and {registeredStore} <> 'NK394' and {registeredStore} <> 'NK395' and {registeredStore} <> 'NK396' and {registeredStore} <> 'NK397')",
          "defaultValueExpression": "iif({registeredStore} = 'NK012' or {registeredStore} = 'NK020' or {registeredStore} = 'NK022' or {registeredStore} = 'NK024' or {registeredStore} = 'NK367' or {registeredStore} = 'NK372' or {registeredStore} = 'NK376' or {registeredStore} = 'NK380', 'Delhi', iif({registeredStore} = 'NK026' or {registeredStore} = 'NK340' or {registeredStore} = 'NK374', 'Gurgaon', iif({registeredStore} = 'NK056' or {registeredStore} = 'NK076' or {registeredStore} = 'NK177' or {registeredStore} = 'NK249' or {registeredStore} = 'NK336' or {registeredStore} = 'NK377' or {registeredStore} = 'NK378' or {registeredStore} = 'NK379' or {registeredStore} = 'NK396', 'Bengaluru', iif({registeredStore} = 'NK095' or {registeredStore} = 'NK097' or {registeredStore} = 'NK175' or {registeredStore} = 'NK342' or {registeredStore} = 'NK348' or {registeredStore} = 'NK362' or {registeredStore} = 'NK368' or {registeredStore} = 'NK371' or {registeredStore} = 'NK373' or {registeredStore} = 'NK389' or {registeredStore} = 'NK390' or {registeredStore} = 'NK391' or {registeredStore} = 'NK392' or {registeredStore} = 'NK393' or {registeredStore} = 'NK395', 'Mumbai', iif({registeredStore} = 'NK114' or {registeredStore} = 'NK117' or {registeredStore} = 'NK162' or {registeredStore} = 'NK349', 'Pune', iif({registeredStore} = 'NK213' or {registeredStore} = 'NK269' or {registeredStore} = 'NK381' or {registeredStore} = 'NK382' or {registeredStore} = 'NK394' or {registeredStore} = 'NK397', 'Ahmedabad', iif({registeredStore} = 'NK383' or {registeredStore} = 'NK384', 'Vadodara', iif({registeredStore} = 'NK385', 'Gandhidham', iif({registeredStore} = 'NK386', 'Anand', iif({registeredStore} = 'NK387', 'Rajkot', iif({registeredStore} = 'NK388', 'Vapi', '')))))))))))",
          "isRequired": true,
          "readOnly": true,
          "choices": [
            "Ahmedabad",
            "Anand",
            "Bengaluru",
            "Delhi",
            "Gandhidham",
            "Gurgaon",
            "Mumbai",
            "Pune",
            "Rajkot",
            "Vadodara",
            "Vapi"
          ]
        },
        {
          "type": "dropdown",
          "name": "customBusinessFields_csf5",
          "visibleIf": "{customBusinessFields_csf3} = 'Store'",
          "title": "Fav store / Nearest store",
          "choices": [
            {
              "value": "Nike, Vegas Dwarka",
              "visibleIf": "{customBusinessFields_csf4} = 'Delhi'"
            },
            {
              "value": "Nike, Ambience Mall",
              "visibleIf": "{customBusinessFields_csf4} = 'Delhi'"
            },
            {
              "value": "Nike, Jawahar Nagar Kamla Ngr",
              "visibleIf": "{customBusinessFields_csf4} = 'Delhi'"
            },
            {
              "value": "Nike, Sec-8, Rohini",
              "visibleIf": "{customBusinessFields_csf4} = 'Delhi'"
            },
            {
              "value": "Nike, CP New (B-Block) (BDA Co.)",
              "visibleIf": "{customBusinessFields_csf4} = 'Delhi'"
            },
            {
              "value": "Nike, Southex",
              "visibleIf": "{customBusinessFields_csf4} = 'Delhi'"
            },
            {
              "value": "Nike, Select Mall",
              "visibleIf": "{customBusinessFields_csf4} = 'Delhi'"
            },
            {
              "value": "Nike, DLF Vasant Kunj",
              "visibleIf": "{customBusinessFields_csf4} = 'Delhi'"
            },
            {
              "value": "Nike, JM Road",
              "visibleIf": "{customBusinessFields_csf4} = 'Pune'"
            },
            {
              "value": "Nike, MG Road(308)",
              "visibleIf": "{customBusinessFields_csf4} = 'Pune'"
            },
            {
              "value": "Nike, My Mall Pune (Pavellion Mall)",
              "visibleIf": "{customBusinessFields_csf4} = 'Pune'"
            },
            {
              "value": "Nike, Phoenix Market City",
              "visibleIf": "{customBusinessFields_csf4} = 'Pune'"
            },
            {
              "value": "Nike, Colaba-4 (COCO)",
              "visibleIf": "{customBusinessFields_csf4} = 'Mumbai'"
            },
            {
              "value": "Nike,JWD",
              "visibleIf": "{customBusinessFields_csf4} = 'Mumbai'"
            },
            {
              "value": "Nike, Viviana Mall",
              "visibleIf": "{customBusinessFields_csf4} = 'Mumbai'"
            },
            {
              "value": "Nike, Malad Infinity Mall",
              "visibleIf": "{customBusinessFields_csf4} = 'Mumbai'"
            },
            {
              "value": "Nike, Malad Inorbit Mall",
              "visibleIf": "{customBusinessFields_csf4} = 'Mumbai'"
            },
            {
              "value": "Nike, Seawood Grand Central",
              "visibleIf": "{customBusinessFields_csf4} = 'Mumbai'"
            },
            {
              "value": "Nike, Ramee Emerald,Linking Road",
              "visibleIf": "{customBusinessFields_csf4} = 'Mumbai'"
            },
            {
              "value": "Nike, Andheri Infinity Mall",
              "visibleIf": "{customBusinessFields_csf4} = 'Mumbai'"
            },
            {
              "value": "Nike, Palladium",
              "visibleIf": "{customBusinessFields_csf4} = 'Mumbai'"
            },
            {
              "value": "Nike, Ghatkopar Mumbai",
              "visibleIf": "{customBusinessFields_csf4} = 'Mumbai'"
            },
            {
              "value": "Nike, Phoenix Bandra Kurla (Mum)",
              "visibleIf": "{customBusinessFields_csf4} = 'Mumbai'"
            },
            {
              "value": "Nike, Sky City",
              "visibleIf": "{customBusinessFields_csf4} = 'Mumbai'"
            },
            {
              "value": "Nike, Ambiance Mall Gurgaon",
              "visibleIf": "{customBusinessFields_csf4} = 'Gurgaon'"
            },
            {
              "value": "Nike, MGF Gurgaon",
              "visibleIf": "{customBusinessFields_csf4} = 'Gurgaon'"
            },
            {
              "value": "Nike, Cyber Hub",
              "visibleIf": "{customBusinessFields_csf4} = 'Gurgaon'"
            },
            {
              "value": "Nike, Indra Nagar",
              "visibleIf": "{customBusinessFields_csf4} = 'Bengaluru'"
            },
            {
              "value": "Nike, Brigade New",
              "visibleIf": "{customBusinessFields_csf4} = 'Bengaluru'"
            },
            {
              "value": "Nike, Forum Mall",
              "visibleIf": "{customBusinessFields_csf4} = 'Bengaluru'"
            },
            {
              "value": "Nike, Jaya Nagar",
              "visibleIf": "{customBusinessFields_csf4} = 'Bengaluru'"
            },
            {
              "value": "Nike, Orion Mall",
              "visibleIf": "{customBusinessFields_csf4} = 'Bengaluru'"
            },
            {
              "value": "Nike, Phoenix Mall",
              "visibleIf": "{customBusinessFields_csf4} = 'Bengaluru'"
            },
            {
              "value": "Nike - Phoenix Mall of Asia",
              "visibleIf": "{customBusinessFields_csf4} = 'Bengaluru'"
            },
            {
              "value": "Nike - Mantri Mall",
              "visibleIf": "{customBusinessFields_csf4} = 'Bengaluru'"
            },
            {
              "value": "Nike, One Mall",
              "visibleIf": "{customBusinessFields_csf4} = 'Ahmedabad'"
            },
            {
              "value": "Nike, CG Road, New Ahmedabad",
              "visibleIf": "{customBusinessFields_csf4} = 'Ahmedabad'"
            },
            {
              "value": "Nike, Atlantis Mall, Prahalad Nagar",
              "visibleIf": "{customBusinessFields_csf4} = 'Ahmedabad'"
            },
            {
              "value": "Nike, 4D",
              "visibleIf": "{customBusinessFields_csf4} = 'Ahmedabad'"
            },
            {
              "value": "Nike, Shreem Shalini Mall, Alkapuri",
              "visibleIf": "{customBusinessFields_csf4} = 'Vadodara'"
            },
            {
              "value": "Nike, Inorbit Mall Vadodara",
              "visibleIf": "{customBusinessFields_csf4} = 'Vadodara'"
            },
            {
              "value": "Nike, Gandhidham",
              "visibleIf": "{customBusinessFields_csf4} = 'Gandhidham'"
            },
            {
              "value": "Nike, Anand",
              "visibleIf": "{customBusinessFields_csf4} = 'Anand'"
            },
            {
              "value": "Nike, Reliance Mega Mall, Rajkot",
              "visibleIf": "{customBusinessFields_csf4} = 'Rajkot'"
            },
            {
              "value": "Nike, Vapi",
              "visibleIf": "{customBusinessFields_csf4} = 'Vapi'"
            }
          ]
        },
        {
          "type": "text",
          "name": "customBusinessFields_csf6",
          "visibleIf": "{customBusinessFields_csf3} = 'Store'",
          "title": "Store Person Name"
        },
        {
          "type": "checkbox",
          "name": "consent",
          "title": "By checking this, I give explicit consent to receive personalized offers and promotional content using the above details.",
          "isRequired": true,
          "choices": [
            "I agree"
          ]
        }
      ]
    }
  ]
}

export {
  gender,
  shoeSizes,
  placeOfRegistration,
  cities,
  storesInCities,
  DefaultFavIcon,
  maritalStatus,
  PwaFormJson,
}